module.exports = __webpack_public_path__ + "static/img/video.d8c4a85b.jpg";